import { TimeRangePickerProps } from 'antd'
import dayjs from 'dayjs'

export const venueRangePresets: TimeRangePickerProps['presets'] = [
  {
    label: 'Last 30 days',
    value: [dayjs().subtract(30, 'day'), dayjs().subtract(1, 'day')],
  },

  {
    label: 'This month',
    value: [dayjs().startOf('month'), dayjs().subtract(1, 'day')],
  },
  {
    label: 'Last month',
    value: [
      dayjs().subtract(1, 'month').startOf('month'),
      dayjs().subtract(1, 'month').endOf('month'),
    ],
  },

  {
    label: 'Last 6 months',
    value: [dayjs().subtract(6, 'month'), dayjs().subtract(1, 'day')],
  },
  {
    label: 'Last 12 months',
    value: [dayjs().subtract(12, 'month'), dayjs().subtract(1, 'day')],
  },
  {
    label: 'This year',
    value: [dayjs().startOf('year'), dayjs().subtract(1, 'day')],
  },
  {
    label: 'Last year',
    value: [
      dayjs().subtract(1, 'year').startOf('year'),
      dayjs().subtract(1, 'year').endOf('year'),
    ],
  },
  {
    label: 'All time',
    value: [dayjs('01/01/1970'), dayjs().subtract(1, 'day')],
  },
]
